<template>
    <uw-content title="通知公告" padding="10px">
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="$refs.drawerCreate.Open()">添加信息</el-button>
        </template>
        <uw-table>
            <template slot="search">
                <news-type-select @onChange="TableSearch" v-model="search.type_id" width="200px" margin="0 5px 0 0" />
                <el-input @input="TableSearch" v-model="search.name" clearable  size="mini" placeholder="标题检索"></el-input>
            </template>
            <template slot="data">
                <vxe-table ref="xTable" height="100%" :data="table" :loading="loading" @sort-change="TableSort" :export-config="{}" :print-config="{}">
                    <vxe-column width="60" field="id" title="ID" sortable></vxe-column>
                    <vxe-column min-width="200" field="name" title="标题">
                        <template #default="{ row }">
                            <el-link type="primary" @click="$refs.drawerWindow.Open(row.id)">
                                <i v-if="row.files_id.length > 0" class="el-icon-paperclip"></i>
                                {{ row.name }}
                            </el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="100" field="type" title="类型"></vxe-column>
                    <vxe-column width="80" field="users_read_id" title="已阅读">
                        <template #default="{ row }">
                            <el-link :underline="false" icon="el-icon-user">{{ row.users_read_id?.length ?? 0 }}</el-link>
                        </template>
                    </vxe-column>
                    <vxe-column width="120" title="创建人">
                        <template #default="{ row }">
                            <div style="display: flex; align-items: center; justify-content: flex-start;">
                                <el-avatar style="margin-right: 5px;" :size="26" :src="row.users_admin?.avatar"> {{ row.users_admin?.name[0] }} </el-avatar>
                                {{  row.users_admin?.name }}
                            </div>
                        </template>
                    </vxe-column>
                    <vxe-column width="140" field="updated_at" title="更新日期"></vxe-column>
                    <vxe-column width="140" field="created_at" title="创建日期"></vxe-column>
                    <vxe-column width="90" title="操作" fixed="right" align="center">
                        <template #default="{ row }">
                            <el-link :underline="false" type="primary" class="w-margin-r-5" @click="$refs.drawerUpdate.Open(row.id)">编辑</el-link>
                            <el-link :underline="false" type="danger" @click="TableDelete(row.id)">删除</el-link>
                        </template>
                    </vxe-column>
                </vxe-table>
            </template>
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>
        </uw-table>
        <news-create ref="drawerCreate" @onChange="TableSearch" />
        <news-update ref="drawerUpdate" @onChange="TableSearch" />
        <news-window ref="drawerWindow" @onChange="TableSearch" />
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
            loading: false,
            table: [],
                        page: {
                total: 0,
                size: 50,
                current: 1,
            },
                        search: {
                type_id: null,
                name: null,
            },
                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },
    mounted () {
        this.TableSearch()
    },
    methods: {
        TableSearch() {
            this.loading = true
            this.$http.post(
                '/9api/news/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['users_admin', 'type'],
                    hidden: ['describe']
                }
            ).then((rps) => {
                                this.page.total = rps.data.total
                this.table = rps.data.body
                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }
                                this.loading = false
            })
        },
        TableSort(column) {
            this.order.method = column.order ? column.order : this.order.method
            this.order.column = column.field
            this.TableSearch()
        },
        TableDelete(id) {
            this.$confirm('数据删除后不可恢复！', '请谨慎操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error',
                center: true
            }).then(() => {
                                this.loading = true
                this.$http.post('/9api/news/delete', { id: id }).then(rps => {
                    this.TableSearch()
                })
            })
        },
    }
}
</script>